<template>
  <Transition name="ing-fade">
    <div v-if="isdisplay" class="ing-overlay" @click.self="close">
      <div class="ing-dialog" role="dialog" aria-modal="true">

        <div class="ing-head">
          <div>
            <h4 class="ing-title">Ingrédients : {{ libelle }}</h4>
            <p class="ing-sub">Retirer ou doubler un ingrédient. Le prix du plat ne change pas.</p>
          </div>
          <button @click="close" type="button" class="ing-close" aria-label="Fermer"><i class="ri-close-line"></i></button>
        </div>

        <div class="ing-body">

          <div v-for="ingredient in ingredients" :key="ingredient.pid" class="ing-row">
            <span class="ing-name">{{ ingredient.name }}</span>
            <div class="ing-seg">
              <button type="button" :class="['ing-opt', { 'ing-opt--on': ingredient.etat==='normal' }]" @click="ingredient.etat='normal'">Normal</button>
              <button v-if="ingredient.retirable" type="button" :class="['ing-opt', 'ing-opt--sans', { 'ing-opt--on': ingredient.etat==='retire' }]" @click="ingredient.etat='retire'">Sans</button>
              <button v-if="ingredient.doublable" type="button" :class="['ing-opt', 'ing-opt--double', { 'ing-opt--on': ingredient.etat==='double' }]" @click="ingredient.etat='double'">Double</button>
            </div>
          </div>

          <div v-if="qteLigne>1" class="ing-nb">
            <span>Appliquer à combien de plats sur {{ qteLigne }} ?</span>
            <div class="ing-stepper">
              <button type="button" @click="nb=Math.max(1,nb-1)" aria-label="Moins">−</button>
              <b>{{ nb }}</b>
              <button type="button" @click="nb=Math.min(qteLigne,nb+1)" aria-label="Plus">+</button>
            </div>
          </div>
          <p v-if="qteLigne>1 && nb<qteLigne" class="ing-info">
            Les {{ nb }} plat(s) modifié(s) passeront sur une ligne à part du ticket.
          </p>

        </div>

        <div class="ing-foot">
          <button @click="close" type="button" class="ing-btn">Annuler</button>
          <button @click="valider" type="button" class="ing-btn ing-btn--ok">Valider</button>
        </div>

      </div>
    </div>
  </Transition>
</template>

<script>
export default {
  /* eslint-disable */
  name: "modalingredients",

  data() {
    return {
      isdisplay: false,
      linekey: "",
      libelle: "",
      qteLigne: 1,
      nb: 1,
      ingredients: [],
    };
  },

  methods: {

    /* @param ligne        ligne du ticket ({ linekey, qtite, article, ingredients })
       @param modifiables  ingrédients modifiables de l'article [{ pid, name, retirable, doublable }] */
    show(ligne, modifiables) {
      const dejaChoisis = {};
      (ligne.ingredients || []).forEach(i => { dejaChoisis[i.pid] = i.etat; });

      this.linekey = ligne.linekey;
      this.libelle = ligne.article ? (ligne.article.libelle || "") : "";
      /* Une quantité fractionnée (vente au poids) ne se découpe pas : tout ou rien. */
      const q = parseFloat(ligne.qtite) || 1;
      this.qteLigne = Number.isInteger(q) ? q : 1;
      this.nb = this.qteLigne;
      this.ingredients = (modifiables || []).map(m => {
        let etat = dejaChoisis[m.pid] || "normal";
        if ((etat === "retire" && !m.retirable) || (etat === "double" && !m.doublable)) etat = "normal";
        return { pid: m.pid, name: m.name, retirable: !!m.retirable, doublable: !!m.doublable, etat };
      });
      this.isdisplay = true;
    },

    close() { this.isdisplay = false; },

    valider() {
      this.$emit("ingredientschoisis", {
        linekey: this.linekey,
        nb: this.nb,
        tout: this.nb >= this.qteLigne,
        ingredients: this.ingredients
            .filter(i => i.etat !== "normal")
            .map(i => ({ pid: i.pid, name: i.name, etat: i.etat })),
      });
      this.isdisplay = false;
    },
  },
};
</script>

<style scoped>
/* Palette héritée de l'écran de caisse (variables --surface, --text...), avec repli clair. */
.ing-overlay { position: fixed; inset: 0; z-index: 1200; display: flex; align-items: center; justify-content: center; padding: 16px; background: rgb(15 23 42 / .55); }
.ing-dialog { width: 100%; max-width: 460px; max-height: 90vh; display: flex; flex-direction: column; border-radius: 14px; background: var(--surface, #fff); color: var(--text, #0f172a); border: 1px solid var(--border, #e2e8f0); box-shadow: 0 20px 50px rgb(0 0 0 / .3); overflow: hidden; }
.ing-head { display: flex; align-items: flex-start; justify-content: space-between; gap: 12px; padding: 14px 16px; border-bottom: 1px solid var(--border, #e2e8f0); }
.ing-title { margin: 0; font-size: 15px; font-weight: 800; }
.ing-sub { margin: 3px 0 0; font-size: 11.5px; color: var(--text2, #64748b); }
.ing-close { width: 30px; height: 30px; flex-shrink: 0; border: none; border-radius: 8px; cursor: pointer; background: transparent; color: var(--text2, #64748b); font-size: 18px; }
.ing-close:hover { color: var(--red, #dc2626); }
.ing-body { padding: 12px 16px; overflow-y: auto; }
.ing-row { display: flex; align-items: center; justify-content: space-between; gap: 12px; padding: 8px 0; border-bottom: 1px dashed var(--border, #e2e8f0); }
.ing-name { font-size: 13.5px; font-weight: 600; min-width: 0; }
.ing-seg { display: flex; gap: 4px; flex-shrink: 0; }
.ing-opt { min-width: 62px; height: 38px; padding: 0 10px; border-radius: 8px; cursor: pointer; font-size: 12.5px; font-weight: 700; border: 1px solid var(--border, #cbd5e1); background: transparent; color: var(--text2, #64748b); }
.ing-opt--on { background: var(--blue, #2563eb); border-color: var(--blue, #2563eb); color: #fff; }
.ing-opt--sans.ing-opt--on { background: var(--red, #dc2626); border-color: var(--red, #dc2626); }
.ing-opt--double.ing-opt--on { background: var(--green, #16a34a); border-color: var(--green, #16a34a); }
.ing-nb { display: flex; align-items: center; justify-content: space-between; gap: 12px; margin-top: 14px; font-size: 13px; font-weight: 600; }
.ing-stepper { display: flex; align-items: center; gap: 10px; }
.ing-stepper button { width: 38px; height: 38px; border-radius: 8px; cursor: pointer; font-size: 18px; font-weight: 700; border: 1px solid var(--border, #cbd5e1); background: transparent; color: var(--text, #0f172a); }
.ing-stepper b { min-width: 26px; text-align: center; font-size: 16px; }
.ing-info { margin: 8px 0 0; font-size: 11.5px; color: var(--text2, #64748b); }
.ing-foot { display: flex; justify-content: flex-end; gap: 8px; padding: 12px 16px; border-top: 1px solid var(--border, #e2e8f0); }
.ing-btn { height: 40px; padding: 0 18px; border-radius: 9px; cursor: pointer; font-size: 13px; font-weight: 700; border: 1px solid var(--border, #cbd5e1); background: transparent; color: var(--text, #0f172a); }
.ing-btn--ok { background: var(--blue, #2563eb); border-color: var(--blue, #2563eb); color: #fff; }
.ing-fade-enter-active, .ing-fade-leave-active { transition: opacity .18s ease; }
.ing-fade-enter-from, .ing-fade-leave-to { opacity: 0; }
</style>
